export default "__VITE_ASSET__9f46792d__"